import {BaseModel} from "./base-model";
import {Task} from "./task";

export class Step extends BaseModel {

  protected static self = Step;

  taskId : string;
  task : Task;
  name : string;
  description : string;
  seekStart : number;
  seekEnd: number;
  sequence : number;
  isNew: boolean;

  public validate(): boolean {
    return true;
  }

  hasSeeks() {
    return this.seekStart > -1 && this.seekEnd > -1;
  }
}


export class StepExecution extends BaseModel {

  protected static self = StepExecution;

  maintenanceId: string;
  taskId: string;
  stepId: string;
  isExecuted: boolean;
  executedAt: number;

  public validate(): boolean {
    return true;
  }
}
